import "./style.css";

export default class SpecialismsHeader {
  static selector = ".specialisms-header";

  constructor(block) {
    this.block = block;
    this.switchGrid = document.getElementById("header-switch-grid");
    this.switchCaption = this.block.querySelector(
      ".specialisms-header__switch-caption"
    );

    this.staticSpecialismsListHead = document.querySelector(
      ".specialisms-list__head"
    );
    this.specialismsListSwitchGrid = document.getElementById("switch-grid");
  }

  checkSpecialismsListHeadPosition = () => {
    if (!this.staticSpecialismsListHead) {
      return;
    }

    // check if specialisms list head above the viewport
    const specialismsListHeadRect = this.staticSpecialismsListHead.getBoundingClientRect();
    const specialismsListHeadBottom = specialismsListHeadRect.bottom;

    if (specialismsListHeadBottom <= 0) {
      this.block.classList.add("specialisms-header--static-above");
    } else {
      this.block.classList.remove("specialisms-header--static-above");
    }
  };

  // Event handlers
  onSwitchChange = e => {
    const { checked } = e.currentTarget;

    if (checked) {
      if (this.switchCaption) {
        this.switchCaption.innerText = "SWITCH TO LIST VIEW";
      }
    } else {
      if (this.switchCaption) {
        this.switchCaption.innerText = "SWITCH TO GRID VIEW";
      }
    }

    this.switchGrid.checked = checked;
  };

  // Public
  onReady = () => {
    this.specialismsListSwitchGrid?.addEventListener(
      "change",
      this.onSwitchChange
    );
  };
  onDestroy = () => {
    this.specialismsListSwitchGrid?.removeEventListener(
      "change",
      this.onSwitchChange
    );
  };
  onResize() {}
  onScroll() {
    this.checkSpecialismsListHeadPosition();
  }
}
